import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IDeleteOpportunitiesByFilterRequest {
	boardId: string;
	filter?: Api.IOpportunitySearchRequest;
	stageId?: string;
	excludeItemIds?: string[];
	confirmWholeBoardDelete?: boolean;
}

export const useDeleteOpportunitiesByFilter = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (deletedCount: number) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			boardId,
			filter,
			stageId,
			excludeItemIds,
			confirmWholeBoardDelete,
		}: IDeleteOpportunitiesByFilterRequest) => {
			return userSession.webServiceHelper.callAsync<number>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `board/${boardId}/items/delete` }),
				'POST',
				{ filter, stageId, excludeItemIds, confirmWholeBoardDelete }
			);
		},
		onError,
		onSuccess,
	});
};
